import React from "react";

const change = 655.957;

export const ConvertEuroToXof = (price) => {
  return Math.ceil(price * change);
};

const CurrencyConverter = (price, currencyFrom, currencyTo) => {
  if (currencyFrom.toLowerCase() === "euro") {
    if (currencyTo.toLowerCase() === "euro") {
      return formatCurrency(roundTwoDecimal(price), "EUR");
    }

    return formatCurrency(ConvertEuroToXof(price), "XOF");
  }

  if (currencyTo.toLowerCase() === "euro") {
    return roundTwoDecimal(price / change) + " €";
  }
  return formatCurrency(price, "XOF");
};

const formatCurrency = (amount, currencyCode) => {
  return new Intl.NumberFormat("fr-FR", {
    style: "currency",
    currency: currencyCode,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(amount);
};

const roundTwoDecimal = (price) => {
  return Math.round(price * 100) / 100;
};

export default CurrencyConverter;
